import React, {PureComponent} from "react"
import {WithDefaultTheme, withTheme} from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import {addLeadingZeros} from "@irati/deals/helpers/deals/countdown"
import {Body, Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"

import {StyledSpan} from "./styled"

interface Props extends WithDefaultTheme {
  days: number,
  hours: number,
  min: number,
  sec: number
}

class Countdown extends PureComponent<Props> {
  render() {
    const {days, hours, min, sec, theme} = this.props

    return (
      <Flex justifyContent="center" margin={`${theme.spacing.three} auto`}>
        <StyledSpan>
          <Body weight="bold" textAlign="center" marginBottom={0}>
            {addLeadingZeros(days)}
          </Body>
          <Label>
            <FormattedMessage id="perks.redemptionEvents.countdown.days.label" values={{days}} />
          </Label>
        </StyledSpan>

        <StyledSpan>
          <Body weight="bold" textAlign="center" marginBottom={0}>
            {addLeadingZeros(hours)}
          </Body>
          <Label>
            <FormattedMessage id="perks.redemptionEvents.countdown.hours.label" values={{hours}} />
          </Label>
        </StyledSpan>

        <StyledSpan>
          <Body weight="bold" textAlign="center" marginBottom={0}>
            {addLeadingZeros(min)}
          </Body>
          <Label>
            <FormattedMessage id="perks.redemptionEvents.countdown.minutes.label" values={{min}} />
          </Label>
        </StyledSpan>

        <StyledSpan>
          <Body weight="bold" textAlign="center" marginBottom={0}>
            {addLeadingZeros(sec)}
          </Body>
          <Label>
            <FormattedMessage id="perks.redemptionEvents.countdown.seconds.label" values={{sec}} />
          </Label>
        </StyledSpan>
      </Flex>
    )
  }
}

export default withTheme(Countdown)
